/* ========================================
   dirty-birdy-header.liquid behavior
   - Predictive search (debounced, keyboard nav, fetch /search/suggest.json)
   - Mobile drawer toggle (hamburger)
   Loaded with `defer`.
   Section id read from data-section-id on the .db-header wrapper so this file
   stays cacheable across instances.
   ======================================== */
(function () {
  'use strict';

  function initPredictiveSearch() {
    var root = document.querySelector('.db-header[data-section-id]');
    if (!root) return;
    var SECTION_ID = root.getAttribute('data-section-id');
    var input = root.querySelector('.db-search-input');
    var panel = document.getElementById('db-predictive-' + SECTION_ID);
    if (!input || !panel) return;
    var inner = panel.querySelector('.db-predictive-inner');
    var form = root.querySelector('.db-search-form');
    var debounceTimer = null;
    var lastQuery = '';
    var focusedIdx = -1;
    var lastFetchToken = 0;

    function close() {
      panel.hidden = true;
      focusedIdx = -1;
    }
    function open() {
      panel.hidden = false;
    }
    function esc(s) {
      var d = document.createElement('div');
      d.textContent = s == null ? '' : String(s);
      return d.innerHTML;
    }

    function render(q, results) {
      var html = '';
      var hasAny = false;

      if (results.queries && results.queries.length) {
        hasAny = true;
        html += '<div class="db-predictive-section"><p class="db-predictive-heading">Suggestions</p>';
        results.queries.forEach(function (it) {
          html += '<a class="db-predictive-suggestion" href="' + esc(it.url) + '">' + esc(it.text) + '</a>';
        });
        html += '</div>';
      }

      if (results.products && results.products.length) {
        hasAny = true;
        html += '<div class="db-predictive-section"><p class="db-predictive-heading">Products</p>';
        results.products.forEach(function (p) {
          var img = p.image
            ? '<img class="db-predictive-img" src="' + esc(p.image) + '" alt="" loading="lazy">'
            : '<div class="db-predictive-img"></div>';
          var price = p.price ? '<span class="db-predictive-price">' + esc(p.price) + '</span>' : '';
          var meta = p.vendor ? '<p class="db-predictive-meta">' + esc(p.vendor) + '</p>' : '';
          html += '<a class="db-predictive-item" href="' + esc(p.url) + '">'
            + img
            + '<div class="db-predictive-text"><p class="db-predictive-title">' + esc(p.title) + '</p>' + meta + '</div>'
            + price
            + '</a>';
        });
        html += '</div>';
      }

      if (results.collections && results.collections.length) {
        hasAny = true;
        html += '<div class="db-predictive-section"><p class="db-predictive-heading">Collections</p>';
        results.collections.forEach(function (c) {
          html += '<a class="db-predictive-suggestion" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
        });
        html += '</div>';
      }

      if (results.pages && results.pages.length) {
        hasAny = true;
        html += '<div class="db-predictive-section"><p class="db-predictive-heading">Pages</p>';
        results.pages.forEach(function (p) {
          html += '<a class="db-predictive-suggestion" href="' + esc(p.url) + '">' + esc(p.title) + '</a>';
        });
        html += '</div>';
      }

      if (hasAny) {
        html += '<a class="db-predictive-all" href="/search?q=' + encodeURIComponent(q) + '">View all results for &ldquo;' + esc(q) + '&rdquo; →</a>';
      } else {
        html += '<div class="db-predictive-empty">No results for &ldquo;' + esc(q) + '&rdquo;</div>';
      }

      inner.innerHTML = html;
      focusedIdx = -1;
      open();
    }

    async function fetchSuggest(q) {
      var token = ++lastFetchToken;
      try {
        var url = '/search/suggest.json'
          + '?q=' + encodeURIComponent(q)
          + '&resources[type]=product,collection,page,query'
          + '&resources[limit]=6'
          + '&resources[options][unavailable_products]=last';
        var res = await fetch(url, { headers: { 'Accept': 'application/json' } });
        if (!res.ok) return;
        if (token !== lastFetchToken) return; // stale
        var data = await res.json();
        var r = (data.resources && data.resources.results) || {};
        render(q, r);
      } catch (e) {
        console.error('Predictive search failed:', e);
      }
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      if (q.length < 2) { close(); lastQuery = ''; return; }
      if (q === lastQuery) return;
      lastQuery = q;
      debounceTimer = setTimeout(function () { fetchSuggest(q); }, 180);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && inner.innerHTML) open();
    });

    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && e.target !== input) close();
    });

    input.addEventListener('keydown', function (e) {
      var items = inner.querySelectorAll('.db-predictive-item, .db-predictive-suggestion, .db-predictive-all');

      if (e.key === 'Escape') { close(); input.blur(); return; }

      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!items.length || panel.hidden) return;
        e.preventDefault();
        items.forEach(function (it) { it.classList.remove('is-focused'); });
        if (e.key === 'ArrowDown') focusedIdx = (focusedIdx + 1) % items.length;
        else focusedIdx = focusedIdx <= 0 ? items.length - 1 : focusedIdx - 1;
        items[focusedIdx].classList.add('is-focused');
        items[focusedIdx].scrollIntoView({ block: 'nearest' });
      }

      if (e.key === 'Enter' && focusedIdx >= 0 && items[focusedIdx]) {
        e.preventDefault();
        window.location.href = items[focusedIdx].href;
      }
    });
  }

  function initMobileDrawer() {
    var drawer = document.getElementById('db-mdrawer');
    if (!drawer) return;
    var burgers = document.querySelectorAll('[data-db-burger]');
    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('db-mdrawer-open');
      burgers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var first = drawer.querySelector('.db-mdrawer-close');
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('db-mdrawer-open');
      burgers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    burgers.forEach(function (b) {
      b.addEventListener('click', function () {
        drawer.classList.contains('is-open') ? close() : open();
      });
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-db-mdrawer-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
    /* Close drawer when user follows a nav link (so SPA-like nav feels right after redirect) */
    drawer.querySelectorAll('a[href]').forEach(function (a) {
      a.addEventListener('click', function () { setTimeout(close, 50); });
    });
  }

  function init() {
    initPredictiveSearch();
    initMobileDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
